type ActionType = 'SET_LANG' | 'TOGGLE_LANG'
type LanguageType = 'TH' | 'EN'

interface Action {
  type: ActionType
  payload: LanguageType
}

const LANG_KEY = 'haup_lang'

const savedLang = localStorage.getItem(LANG_KEY)
const initialLang: LanguageType = savedLang === 'EN' ? 'EN' : 'TH'

export default (state: LanguageType = initialLang, action: Action): LanguageType => {
  switch (action.type) {
    case 'SET_LANG': {
      localStorage.setItem(LANG_KEY, action.payload)
      return action.payload
    }
    case 'TOGGLE_LANG': {
      const next = state === 'TH' ? 'EN' : 'TH'
      localStorage.setItem(LANG_KEY, next)
      return next
    }
    default:
      return state
  }
}
